module.exports = "/* Header */\n#collections-container-contact {\n  height: 100vh;\n  overflow: hidden;\n  background-image: url(\"/assets/img/contactanos.jpg\");\n  background-size: cover; }\n#collections-container-contact__item {\n    cursor: pointer; }\n#collections-container-contact__item img {\n      max-height: 70vh;\n      max-width: 340px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.scss
// module id = ./src/app/contact/contact.component.scss
// module chunks = main